import React, { useState, useEffect, useRef } from "react";
import { Modal, Form, Input, Button, notification, Select } from "antd";
import { callApi } from "../../api/apiCaller";
import { GreenNotify, RedNotify } from "../../helper/helper";
import routes from "../../api/routes";
import { Buffer } from "buffer";
import AWS from "aws-sdk";
const { Option } = Select;
AWS.config.update({
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  region: "us-east-2",
});

const UpdateOrganizer = ({
  visible,
  item,
  toggleModal,
  recordData,
  addProduct,
  setAddProduct,
}) => {
  const [form] = Form.useForm();
  const [isloading, setIsLoading] = useState(false);
  const [image, setImage] = useState(null);
  const [fileError, setFileError] = useState("");
  const fileInputRef = useRef(null);
  useEffect(() => {
    if (visible && recordData) {
      console.log("record data", recordData);
      form.setFieldsValue({
        name: recordData?.name,
      });
      //setImage(recordData.img || PLACEHOLDER_IMAGE);
    }
  }, [visible, recordData, form]);

  const pickImageFile = () => {
    fileInputRef.current.click();
  };

  const uploadImageOnS3 = async (src) => {
    return new Promise((resolve, reject) => {
      try {
        const reader = new FileReader();
        reader.onload = async () => {
          const S3 = new AWS.S3();
          const params = {
            Bucket: "goodeway",
            Key: `${10000 + Math.round(Math.random() * 10000)}.png`,
            Body: Buffer.from(
              reader.result.replace(/^data:image\/\w+;base64,/, ""),
              "base64"
            ),
          };
          let res = await S3.upload(params).promise();
          console.log(res);
          return resolve(res.Location);
        };
        reader.onerror = (e) => console.log("OOPS!", e);
        reader.readAsDataURL(src);
      } catch (error) {
        console.error("Error uploading to S3:", error);
        reject(error);
      }
    });
  };

  const handleFileChange = (event) => {
    const fileList = event.target.files;

    if (fileList.length > 0) {
      const file = fileList[0];

      const reader = new FileReader();
      reader.onloadend = async () => {
        const thubnailUrl = await uploadImageOnS3(file);
        console.log("urls3 ", thubnailUrl);
        setImage(thubnailUrl);
        setFileError("");
      };
      reader.readAsDataURL(file);
    } else {
      setFileError("Please select a file.");
    }
  };

  const handleSave = () => {
    // Disable the button up front so a slow save cannot be double-submitted; validation
    // failures re-enable it in the .catch below.
    setIsLoading(true);
    form
      .validateFields()
      .then((values) => {
        const requestBody = {
          ...values,
          img: image,
        };
        console.log("requestBody", requestBody);
        callApi(
          "POST",
          `${routes.addAboutUs}`,
          requestBody,
          setIsLoading,
          (res) => {
            console.log("Response", res);
            if (res.status === 409) {
              RedNotify("Already exists you cannot create more than one");
            } else if (res.status === 200) {
              GreenNotify("About Us Created Successfully");
              toggleModal();
            } else {
              console.log("else :::", res);
              RedNotify("Error Occurred. Please try again later.");
            }
          },
          (error) => {
            console.error("API Call Error:", error);
            RedNotify(
              "An error occurred during the API call. Please try again later.",
              error
            );
          }
        );
      })
      .catch((errorInfo) => {
        setIsLoading(false);
        console.error("Validation Error:", errorInfo);
      });
  };

  return (
    <Modal
      title={"Create About"}
      visible={visible}
      onCancel={toggleModal}
      footer={[
        <Button key="cancel" onClick={toggleModal}>
          Cancel
        </Button>,
        <Button
          key="save"
          type="primary"
          onClick={handleSave}
          loading={isloading}
          disabled={isloading}
        >
          Save
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Text"
          name="text"
          rules={[
            { required: true, message: "Please enter the about us text" },
          ]}
        >
          <Input.TextArea autoSize={{ minRows: 2, maxRows: 6 }} />
        </Form.Item>

        {/* <div
          onClick={pickImageFile}
          style={{ marginBottom: "2rem" }}
          className="add-product-modal-input-title"
        >
          <h2> Image</h2>
          <div className="add-product-modal-image">
            <img src={image ? image : PLACEHOLDER_IMAGE} alt="" />
          </div>
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileChange}
            required
          />
          {fileError && <p style={{ color: "red" }}>{fileError}</p>}
        </div> */}
      </Form>
    </Modal>
  );
};

export default UpdateOrganizer;
